export default "__VITE_PUBLIC_ASSET__2d4bfb6c__"